import { render, staticRenderFns } from "./privacyGuide.vue?vue&type=template&id=d86a76e0&scoped=true"
import script from "./privacyGuide.vue?vue&type=script&lang=js"
export * from "./privacyGuide.vue?vue&type=script&lang=js"
import style0 from "./privacyGuide.vue?vue&type=style&index=0&id=d86a76e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86a76e0",
  null
  
)

export default component.exports